import { h } from 'preact';
import failimage from "./fail.jpg";
import successimage from "./success.jpg";

const ResultPage = ({ questions, answers, onRetry }) => {
  const correctCount = answers.reduce((count, answer, index) => {
    return count + (answer.toLowerCase() === questions[index].answer.toLowerCase() ? 1 : 0);
  }, 0);
  const percentage = (correctCount / questions.length) * 100;
  const isPassed = percentage >= 80;

  return h(
    'div',
    { className: 'container result-container' },
    h('h2', { className: 'title' }, '試験結果'),
    h('div', { className: 'score-section' },
      h('p', { className: 'score' },
        `${questions.length}問中${correctCount}問正解`
      ),
      h('p', { className: 'percentage' },
        `正答率: ${percentage.toFixed(1)}%`
      ),
    ),
    // Add image display section
    h('div', { className: 'result-image-container' },
      h('img', {
        src: isPassed ? successimage : failimage,
        alt: isPassed ? '合格画像' : '不合格画像',
        className: 'result-image',
          width: 512,
	  height: 512,
      })
    ),
    h('div', {
      className: `result-status ${isPassed ? 'passed' : 'failed'}`
    },
      h('h3', null, isPassed ? '合格！おめでとうございます！' : '不合格：解雇です。')
    ),
    h('div', { className: 'answers-table' },
      h('h3', null, '問題の正誤'),
      questions.map((question, index) =>
        h('div', {
          key: question.id,
          className: `answer-row ${
            answers[index].toLowerCase() === question.answer.toLowerCase()
              ? 'correct'
              : 'incorrect'
          }`
        },
          h('p', { className: 'question-text' }, question.text),
          h('div', { className: 'answer-details' },
            h('p', null, `あなたの回答: ${answers[index]}`),
            h('p', null, `正解: ${question.answer}`),
            h('span', { className: 'result-mark' },
              answers[index].toLowerCase() === question.answer.toLowerCase() ? '○' : '×'
            )
          )
        )
      )
    ),
    h('button', {
      onClick: onRetry,
      className: 'button retry-button'
    }, '最初からやり直す')
  );
};

export default ResultPage;



/** WEBPACK FOOTER **
 ** ./src/ResultPage.js
 **/